import { FC } from "react";
import { IAthlete, ICoach, IUser2 } from "../../../models/user copy";
import CustomSelectInput from "../../../shared/CustomSelectInput/CustomSelectInput";
import { useEndpoints } from "../../../hooks/useEndpoints";
import { genericLoadOptions } from "../../../lib/DurationPicker/utils";
import { ISpace } from "../../../models/Space";
import { ITeam } from "../../../models/Team";
import { USER_TYPES } from "../../../enums/user";
import Typhography from "../../../shared/Typhography/Typhography";
import { XIcon } from "@phosphor-icons/react";
import style from "./CoachesTab.module.scss";
import { formatFullName } from "../../../utils/functions";

export const CoachesTab: FC<{
  coaches: ICoach[] | IAthlete[];
  space: ISpace<ITeam>;
  type: "coaches" | "athletes";
  onChange: (coaches: ICoach | IAthlete[]) => void;
}> = ({ space, coaches, onChange, type }) => {
  const { getUsers } = useEndpoints();

  const promiseOptions = genericLoadOptions(
    getUsers,
    (user: IUser2) => ({
      label: formatFullName(user.firstName, user.lastName),
      value: user,
    }),
    {
      spaceId: space._id,
      type: type === "coaches" ? USER_TYPES.COACH : USER_TYPES.ATHLETE,
    }
  );

  const onSelect = (item: { label: string; value: ICoach | IAthlete }) => {
    if (coaches.some(({ _id }) => _id === item.value._id)) return;
    onChange([...coaches, item.value] as ICoach | IAthlete[]);
  };

  const onClickDeleteCoach = (id: string) => {
    onChange(
      coaches.filter(({ _id }) => _id !== id) as
        | ICoach<string>
        | IAthlete<string>[]
    );
  };
  return (
    <div className="row g-3">
      <div className="col-sm-12 col-12">
        <CustomSelectInput
          autoHeight
          label={`Cerca ${type === "coaches" ? "coach" : "atleta"}...`}
          isOptionSelected={(option: any) => {
            return coaches.some((coach) => coach._id === option.value._id);
          }}
          onChange={(value) => {
            onSelect(value);
          }}
          value={null}
          placeholder="Cerca per nome, cognome o email..."
          loadOptions={promiseOptions}
        />
      </div>

      <div className="col-sm-12 col-12">
        <div className="w-100 d-flex flex-wrap gap-1">
          {coaches.map((coach) => (
            <div className={style.coachContainer} key={coach._id}>
              <Typhography size="medium-12">
                {formatFullName(coach.firstName, coach.lastName)}
              </Typhography>
              <XIcon
                className={style.closeIcon}
                onClick={() => {
                  onClickDeleteCoach(coach._id);
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
